import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { useStrategyMemosInfiniteQueryKey } from './useStrategyMemosInfiniteQueryKey'

export const useInvalidateStrategyMemosInfiniteQuery = () => {
  const queryClient = useQueryClient()
  const queryKey = useStrategyMemosInfiniteQueryKey()

  return React.useCallback(
    () => queryClient.invalidateQueries({ queryKey }),
    [queryKey, queryClient],
  )
}
